import { render } from "./POpage.vue?vue&type=template&id=d61f08a2"
import script from "./POpage.vue?vue&type=script&lang=js"
export * from "./POpage.vue?vue&type=script&lang=js"

import "./POpage.vue?vue&type=style&index=0&id=d61f08a2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__